export interface IWinMeter {
    hideWinMeter(): void;

    countUp(from: number, to: number, duration: number, callback: Function): void;

    stopAfterShowingFinalValue(value: number, clearMeterAfterPause: boolean): void;

    stopFinalValueTimer(): void;

    snapToFinalValue(): void;

    setValueIfPlaying(value: number): void;
}
